import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { renderDropdownWithoutLabel } from '../../../../common/inputField';
import { updateSFRReport } from '../../../../api/andrologyApi';
import { toast } from 'sonner';
import FreezingInventory from './freezingInventory';

function SemenFreezingAnalyticsTable({ sfrInventory, setSfrInventory }) {
  const changeFate = async (e, index, patientId, id, cryopreservation) => {
    try {
      console.log(e.target.value, index, patientId, id);
      await updateSFRReport(patientId, {
        cryopreservation: {
          ...cryopreservation,
          fateOfRemainingVials: e.target.value,
        },
        id: id,
      });
      toast.success('Fate of remaining vials updated successfully');
    } catch (error) {
      toast.error('Error updating DFI report');
      console.error('Error updating DFI report:', error);
    }
  };
  const handleRowClick = (e, item) => {
    setSfrInventory({
      open: true,
      data: item,
    });
  };

  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  return (
    <>
      {!sfrInventory.open && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 700 }}>Patient Name</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Patient Age</TableCell>
                <TableCell style={{ fontWeight: 700 }}>MPID</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Spouse Name</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Spouse Age</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Date</TableCell>
                <TableCell style={{ fontWeight: 700 }}>ReportId</TableCell>
                {/* <TableCell style={{ fontWeight: 700 }}>Parent ReportId</TableCell> */}
                <TableCell style={{ fontWeight: 700 }}>
                  No. of Days Abstinence
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Sample Complete/Incomplete
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Appearance</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Liquefaction Time
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Viscosity</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Volume</TableCell>
                <TableCell style={{ fontWeight: 700 }}>pH</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Agglutination</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Round Cell Count
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Sperm Count</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Total Count</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Motility (%)</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  a. Progressive
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  b. Non-Progressive
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>c. Immotile</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Viability (%live)
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Semen Cryopreserved
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Purpose</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Freezing Duration
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Date of Expiry
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Number of Vials Stored
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Tank No.</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Canister No.</TableCell>
                <TableCell style={{ fontWeight: 700 }}>Cane</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Date of Thawing
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Purpose of Thawing
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Number of Vials Thawed
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Number of vials remaining
                </TableCell>
                <TableCell style={{ fontWeight: 700 }}>Expiry</TableCell>
                <TableCell style={{ fontWeight: 700 }}>
                  Fate Of remaining vials
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow
                  sx={{
                    cursor: 'pointer',
                  }}
                  hover
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRowClick(e, item);
                  }}
                >
                  <TableCell>
                    {item.patientGender === 'male'
                      ? item.patientName
                      : item.partnerName}
                  </TableCell>
                  <TableCell>
                    {item.patientGender === 'male'
                      ? item.patientAge
                      : item.partnerAge}
                  </TableCell>
                  <TableCell>{item.upid}</TableCell>
                  <TableCell>
                    {item.patientGender === 'male'
                      ? item.partnerName
                      : item.patientName}
                  </TableCell>
                  <TableCell>
                    {item.patientGender === 'male' ? item.partnerAge : item.Age}
                  </TableCell>
                  <TableCell sx={{ minWidth: '160px' }}>
                    {new Date(item.createdAt).toLocaleDateString('en-uk')}
                  </TableCell>
                  <TableCell>{item.id === '' ? 'N/A' : item.id}</TableCell>
                  {/* <TableCell>
                {item?.parentId === '' || !item?.parentId ? 'N/A' : item?.parentId}
              </TableCell> */}
                  <TableCell>
                    {item.patientDetails
                      ? item?.patientDetails?.abstinenceDays === ''
                        ? 'N/A'
                        : item?.patientDetails?.abstinenceDays
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item.patientDetails
                      ? item?.patientDetails?.sample === ''
                        ? 'N/A'
                        : item?.patientDetails?.sample
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.seminalFluidAnalysis
                      ? item?.seminalFluidAnalysis?.appearance === ''
                        ? 'N/A'
                        : item?.seminalFluidAnalysis?.appearance
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.seminalFluidAnalysis
                      ? item?.seminalFluidAnalysis?.liquefactionTime === ''
                        ? 'N/A'
                        : item?.seminalFluidAnalysis?.liquefactionTime
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.seminalFluidAnalysis
                      ? item?.seminalFluidAnalysis?.viscosity === ''
                        ? 'N/A'
                        : item?.seminalFluidAnalysis?.viscosity
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.seminalFluidAnalysis
                      ? item?.seminalFluidAnalysis?.volume === ''
                        ? 'N/A'
                        : item?.seminalFluidAnalysis?.volume
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.seminalFluidAnalysis
                      ? item?.seminalFluidAnalysis?.ph === ''
                        ? 'N/A'
                        : item?.seminalFluidAnalysis?.ph
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.seminalFluidAnalysis
                      ? item?.seminalFluidAnalysis?.agglutination === ''
                        ? 'N/A'
                        : item?.seminalFluidAnalysis?.agglutination
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.seminalFluidAnalysis
                      ? item?.seminalFluidAnalysis?.roundCellCount === ''
                        ? 'N/A'
                        : item?.seminalFluidAnalysis?.roundCellCount
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.spermAnalysis
                      ? item?.spermAnalysis?.spermCount === ''
                        ? 'N/A'
                        : item?.spermAnalysis?.spermCount
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.spermAnalysis
                      ? item?.spermAnalysis?.totalCount === ''
                        ? 'N/A'
                        : item?.spermAnalysis?.totalCount
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.spermAnalysis
                      ? item?.spermAnalysis?.motility === ''
                        ? 'N/A'
                        : item?.spermAnalysis?.motility
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.spermAnalysis
                      ? item?.spermAnalysis?.progression === ''
                        ? 'N/A'
                        : item?.spermAnalysis?.progression
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.spermAnalysis?.nonProgression === ''
                      ? 'N/A'
                      : item?.spermAnalysis?.nonProgression}
                  </TableCell>
                  <TableCell>
                    {item?.spermAnalysis?.immotile === ''
                      ? 'N/A'
                      : item?.spermAnalysis?.immotile}
                  </TableCell>
                  <TableCell>
                    {item?.spermAnalysis?.viability === ''
                      ? 'N/A'
                      : item?.spermAnalysis?.viability}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.semenCryoPreserved === ''
                      ? 'N/A'
                      : item?.cryopreservation?.semenCryoPreserved}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.purpose === ''
                      ? 'N/A'
                      : item?.cryopreservation?.purpose}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.freezingDuration?.years === '' ||
                    null
                      ? 'N/A'
                      : item?.cryopreservation?.freezingDuration?.years +
                        'years'}
                    {item?.cryopreservation?.freezingDuration?.months === '' ||
                    null
                      ? ''
                      : item?.cryopreservation?.freezingDuration?.months +
                        'months'}{' '}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.originalDateOfExpiry ??
                      item?.cryopreservation?.dateOfExpiry ??
                      'N/A'}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.noOfVialsStored === ''
                      ? 'N/A'
                      : item?.cryopreservation?.noOfVialsStored}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.tankNo === ''
                      ? 'N/A'
                      : item?.cryopreservation?.tankNo}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.canisterNo === ''
                      ? 'N/A'
                      : item?.cryopreservation?.canisterNo}
                  </TableCell>
                  <TableCell>
                    {item?.cryopreservation?.cane === ''
                      ? 'N/A'
                      : item?.cryopreservation?.cane}
                  </TableCell>
                  <TableCell>
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length >
                        1 && (
                        <Table>
                          <TableBody>
                            {item.freezingInventory?.CryopreservationDetails.map(
                              (item, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {item.dateOfThawing === ''
                                      ? 'N/A'
                                      : item.dateOfThawing}
                                  </TableCell>
                                </TableRow>
                              ),
                            )}
                          </TableBody>
                        </Table>
                      )}
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length ===
                        1 &&
                      (item.freezingInventory?.CryopreservationDetails[0]
                        .dateOfThawing === ''
                        ? 'N/A'
                        : item.freezingInventory?.CryopreservationDetails[0]
                            .dateOfThawing)}
                    {!item.freezingInventory && 'N/A'}
                  </TableCell>

                  <TableCell>
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length >
                        1 && (
                        <Table>
                          <TableBody>
                            {item.freezingInventory?.CryopreservationDetails.map(
                              (item, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {item.purposeOfThawing === ''
                                      ? 'N/A'
                                      : item.purposeOfThawing}
                                  </TableCell>
                                </TableRow>
                              ),
                            )}
                          </TableBody>
                        </Table>
                      )}
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length ===
                        1 &&
                      (item.freezingInventory?.CryopreservationDetails[0]
                        .purposeOfThawing === ''
                        ? 'N/A'
                        : item.freezingInventory?.CryopreservationDetails[0]
                            .purposeOfThawing)}
                    {!item.freezingInventory && 'N/A'}
                  </TableCell>

                  <TableCell>
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length >
                        1 && (
                        <Table>
                          <TableBody>
                            {item.freezingInventory?.CryopreservationDetails.map(
                              (item, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {item.numberOfVialsThawed === ''
                                      ? 'N/A'
                                      : item.numberOfVialsThawed}
                                  </TableCell>
                                </TableRow>
                              ),
                            )}
                          </TableBody>
                        </Table>
                      )}
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length ===
                        1 &&
                      (item.freezingInventory?.CryopreservationDetails[0]
                        .numberOfVialsThawed === ''
                        ? 'N/A'
                        : item.freezingInventory?.CryopreservationDetails[0]
                            .numberOfVialsThawed)}
                    {!item.freezingInventory && 'N/A'}
                  </TableCell>

                  <TableCell>
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length >
                        1 && (
                        <Table>
                          <TableBody>
                            {item.freezingInventory?.CryopreservationDetails.map(
                              (item, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {item.numberOfVialsRemaining === ''
                                      ? 'N/A'
                                      : item.numberOfVialsRemaining}
                                  </TableCell>
                                </TableRow>
                              ),
                            )}
                          </TableBody>
                        </Table>
                      )}
                    {item.freezingInventory &&
                      item.freezingInventory?.CryopreservationDetails.length ===
                        1 &&
                      (item.freezingInventory?.CryopreservationDetails[0]
                        .numberOfVialsRemaining === ''
                        ? 'N/A'
                        : item.freezingInventory?.CryopreservationDetails[0]
                            .numberOfVialsRemaining)}
                    {!item.freezingInventory && 'N/A'}
                  </TableCell>

                  <TableCell>
                    {item.freezingInventory
                      ? item?.freezingInventory.dateOfExpiry === ''
                        ? 'N/A'
                        : item?.freezingInventory.dateOfExpiry
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {renderDropdownWithoutLabel(
                      'fateOfRemainingVials',
                      item?.cryopreservation?.fateOfRemainingVials,
                      [' ', 'Continue Freezing', 'Discard', 'Other'],
                      (e, index) => {
                        changeFate(
                          e,
                          index,
                          item.patientId,
                          item.id,
                          item.cryopreservation,
                        );
                      },
                      index,
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {sfrInventory.open && (
        <FreezingInventory
          dataAnalyticsSfr={sfrInventory}
          setDataAnalyticsSfr={setSfrInventory}
        />
      )}
    </>
  );
}

export default SemenFreezingAnalyticsTable;
